<div class="fixed flex h-4rem p-3 w-full" style="background-color: aqua; left: 280px">
  <div class="align-items-center flex" style="background-color: yellow; width: calc(100% - 280px)">header</div>
</div>
